import { useEffect, useState } from 'react';

const SplashScreen = ({ onComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fade out after 2 seconds
    const fadeTimer = setTimeout(() => {
      setFadeOut(true);
    }, 2000);

    // Complete after fade animation (2.5 seconds total)
    const completeTimer = setTimeout(() => {
      onComplete();
    }, 2500);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center transition-opacity duration-500 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
      style={{ backgroundColor: '#FCFCF8', zIndex: 9999 }}
    >
      <div className="flex flex-col items-center">
        <img
          src="https://customer-assets.emergentagent.com/job_ranch-social/artifacts/cprb8mpd_Logo%20cream.png"
          alt="WILD"
          className="w-80 h-auto animate-pulse"
        />
      </div>
    </div>
  );
};

export default SplashScreen;
